<article>
	<section>
		<div>{{hour}}</div>
		<div>{{value | number:'0.2-2'}} <span>kWh</span></div>
		<div>{{timestamp}}</div>
	</section>
</article>
